class LoginController extends AbstractController
	@register()
	@inject '$state',
		'$stateParams'
		'translate'
		'MessageTerminal'
		'ConfigurationService'
		'AuthenticationService'
		'GOOGLE_AUTH_CLIENT_ID'
		'MICROSOFT_AUTH_CLIENT_ID'
		'MICROSOFT_AUTH_TENANT_ID'

	initialize: ->
		@identifier = if @$stateParams.identifier? then @$stateParams.identifier else null
		@username = ''
		@password = ''
		@isMasterUser = !@identifier?

		@initializeGoogleLogin()
		@initializeMicrosoftLogin()

	initializeGoogleLogin: ->
		###
		All URLs must be whitelisted, overwise Google will throw unauthorized exception

		To add new URL:
			- Go to Google Auth Platform console (76241313147 is from wallmobpos@gmail.com account)
			- Select Clients > Backoffice
			- Under "Authorised JavaScript origins" add new URL

		@link https://console.cloud.google.com/auth/clients/76241313147-26f1en5h9j4711fuapgf4lsvs1ei61l6.apps.googleusercontent.com
		###
		google.accounts.id.initialize({
			client_id: @GOOGLE_AUTH_CLIENT_ID
			use_fedcm_for_prompt: true
			context: 'signin'
			ux_mode: 'popup'
			nonce: @Guid.randomString()
			callback: (credentials) => @loginWithGoogleToken(credentials.credential)
		})
		# There is no options as second argument, because we hide this button in UI anyway
		google.accounts.id.renderButton(angular.element('#google-login-button-wrapper')[0], {})
		# Show Google One Tap prompt. 1password will block request, but will show "Login with Google" if it's saved item
		google.accounts.id.prompt()

	signInWithGoogle: ->
		angular.element('#google-login-button-wrapper div').click()

	initializeMicrosoftLogin: ->
		###
		Uses Microsoft Authentication Library (MSAL) browser SDK to authenticate against Microsoft Entra ID (Azure AD).

		To register/configure the application:
			- Go to Microsoft Entra admin center > App registrations
			- Select the Backoffice application
			- Under "Authentication" add this Backoffice URL as a Single-page application redirect URI
			- The client (application) id is provided via MICROSOFT_AUTH_CLIENT_ID constant
			- The directory (tenant) id is provided via MICROSOFT_AUTH_TENANT_ID constant

		@link https://learn.microsoft.com/entra/identity-platform/quickstart-register-app
		###
		@microsoftClient = new msal.PublicClientApplication({
			auth:
				clientId: @MICROSOFT_AUTH_CLIENT_ID
				authority: "https://login.microsoftonline.com/organizations"
				redirectUri: "#{window.location.origin}/login"
			cache:
				cacheLocation: 'sessionStorage'
		})

		@microsoftInitialized = @microsoftClient.initialize()

	signInWithMicrosoft: ->
		@microsoftInitialized
			.then =>
				return @microsoftClient.loginPopup({
					scopes: ['openid', 'profile', 'email']
					nonce: @Guid.randomString(),
					overrideInteractionInProgress: true
				})
			.then (response) =>
				@loginWithMicrosoftToken(response.idToken)
			.catch (error) =>
				# User dismissing the SSO popup is not an error worth surfacing.
				# Also clear the MSAL interaction lock so the button works on retry.
				if error?.errorCode in ['user_cancelled', 'popup_window_error']
					return

				@handleErrors error, 'wbo.login.error.failed'

	checkEmail: ->
		if @form.$error.pattern
			@errorMessage = @translate('warning.invalid.email.address')
		else
			@errorMessage = ''

	login: ->
		# Ugly fix for when browsers autofill form before angular bootstraps
		@username = document.getElementById("LoginForm_username").value
		@password = document.getElementById("LoginForm_password").value

		if _.isEmpty @username
			@errorMessage = @translate('wbo.login.error.username')

			return

		if _.isEmpty @password
			@errorMessage = @translate('wbo.login.error.password')

			return

		if @isMasterUser
			@identifier = null

		@_doLogin(@username, @password, @identifier)

	loginWithGoogleToken: (token) ->
		@_doLogin null, null, @_ssoIdentifier(), token

	loginWithMicrosoftToken: (token) ->
		@_doLogin null, null, @_ssoIdentifier(), null, token

	_ssoIdentifier: ->
		if @isMasterUser then null else @identifier

	_doLogin: (username, password, identifier, googleToken, microsoftToken) ->
		@loggingIn = true

		@AuthenticationService
			.login {username: username, password: password, identifier: identifier, googleToken: googleToken, microsoftToken: microsoftToken}
			.then =>
				@MessageTerminal.publish @MessageTerminal.events.REFRESH
				@MessageTerminal.publish @MessageTerminal.events.LOGIN
				@$state.go(@ConfigurationService.get('Backoffice.Home.DefaultState', true))
			.catch (error) =>
				@handleErrors error
				@errorMessage = @translate('wbo.login.error.failed')
			.finally =>
				@loggingIn = false
